import { render } from "./GeneralColorField.vue?vue&type=template&id=556d7ba3&scoped=true"
import script from "./GeneralColorField.vue?vue&type=script&lang=js"
export * from "./GeneralColorField.vue?vue&type=script&lang=js"

import "./GeneralColorField.vue?vue&type=style&index=0&id=556d7ba3&lang=stylus&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556d7ba3"]])

export default __exports__